<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Concepto' : 'Nuevo Concepto' }}</span></h3>
            </v-card-title>
            <v-card-text>
            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm4>
                  <v-text-field
                      ref="code"
                      prepend-icon="code"
                      v-model="form.code"
                      :rules="[v => !!v || 'Codigo es requerido']"
                      label="Codigo"
                      required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field
                      ref="name"
                      prepend-icon="featured_play_list"
                      v-model="form.name"
                      :rules="[v => !!v || 'Nombre es requerido']"
                      label="Nombre"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

             <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm4>
                  <v-select
                    v-model="form.category_id"
                    prepend-icon="description"
                    :items="categorias"
                    :rules="[v => !!v || 'Categoria es requerido']"
                    item-text="name"
                    item-value="id"
                    label="Categoria"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    v-model="form.concept_id"
                    prepend-icon="description"
                    :items="concepts_father"
                    item-text="name"
                    item-value="id"
                    label="Concepto Dependiente"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm4>
                  <v-menu
                    ref="menu"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="form.start_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha de Inicio"
                      v-model="computedDateFormattedFecha"
                      hint="DD/MM/YYYY formato"
                      prepend-icon="event"
                      :rules="[v => !!v || 'Fecha de inicio es requerida']"
                      required
                      readonly
                    ></v-text-field>
                    <v-date-picker color="primary" :max="new Date().toISOString().slice(0,10)" v-model="form.start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(form.start_date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm8>
                  <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                    <div class="v-input__prepend-outer">
                      <div class="v-input__icon v-input__icon--prepend">
                      </div>
                    </div>
                    <div class="v-input__control">
                      <div class="v-input__slot">
                        <div class="v-text-field__slot">
                          <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto</label>
                          <vue-numeric currency="BsS" v-model="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                        </div>
                      </div>
                      <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                          <div class="v-messages__wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm8>
              <v-text-field
                ref="cuota"
                type="number"
                prepend-icon="code"
                v-model="form.cuota"
                label="Número Cuota"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                ref="description"
                prepend-icon="location_city"
                v-model="form.description"
                :rules="[v => !!v || 'La descripción es requerida']"
                label="Descripción"
                auto-grow
                box
                rows="1"
                required
                ></v-textarea>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.comision"
                    label="Comisión"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.cajaahorros"
                    label="Caja Ahorros"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.inscripcion"
                    label="Inscripción"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.delivery"
                    label="Delivery"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.se"
                    label="Servicio Electrónico"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.sostenimiento"
                    label="Sostenimiento"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>   

            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>

                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="form.especial"
                    label="Especial"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field 
                    v-model="form.sales_limit" 
                    type="number" 
                    label="Limite en Ventas" 
                    append-outer-icon="add" 
                    @click:append-outer="incrementLimits" 
                    prepend-icon="remove" 
                    :min="1"
                    @change="cambioSalesLimit"
                    @click:prepend="decrementLimits">
                  </v-text-field>
                </v-flex>  

              </v-layout>
            </v-flex>   

            </v-card-text>
            <v-card-actions>
                <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : 'Crear' }}</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import VueNumeric from 'vue-numeric'

export default {
  name: 'form-role-view',

  props: {

    loading: {
      type: Boolean,
      required: true
    },

    tipo: {
      type: String,
      required: true
    },

    datos: {
      type: Object,
      required: true
    }

  },

  components: {
    VueNumeric
  },

  computed: {

    computedDateFormattedFecha () {
      return this.formatDate(this.form.start_date)
    }

  },

  watch: {
    datos(v) {
      console.log(v)
      this.$refs.form.resetValidation()
      if (this.tipo == "crear" || this.tipo == "") {
        this.form = {
          code: '',
          name: '',
          cuota: '',
          especial: '',
          category_id: '',
          concept_id: 0,
          amount: 0,
          start_date: '',
          description: '',
          comision: false,
          cajaahorros: false,
          sostenimiento: false,
          inscripcion: false,
          delivery: false,
          parroquia: [],
          se: false,
          sales_limit: 1,
        }
      }else if (this.tipo == "editar") {
        var d = new Date(v.start_date).toISOString().slice(0,10);
        v.start_date = d
        let cat = this.categorias.find(c => c.name == v.categoria)
        v.category_id = cat.id
        Object.assign(this.form, v)
        if(v.concept_id == null){
          this.form.concept_id = 0
        }
        if(v.cuota == null){
          this.form.cuota = ''
        }
      }
    }
  },

  data: () => ({
    valid: false,
    categorias: [],
    concepts_father: [],
    date: null,
    menu: false,
    form: new Form({
        code: '',
        name: '',
        especial: '',
        category_id: '',
        concept_id: 0,
        amount: 0,
        start_date: '',
        cuota: '',
        description: '',
        comision: false,
        cajaahorros: false,
        sostenimiento: false,
        inscripcion: false,
        delivery: false,
        parroquia: [],
        se: false,
        sales_limit: 1,
    }),
    years: [2019,2020],
    months: [
      {id: 1, name: 'ENERO'},
      {id: 2, name: 'FEBRERO'},
      {id: 3, name: 'MARZO'},
      {id: 4, name: 'ABRIL'},
      {id: 5, name: 'MAYO'},
      {id: 6, name: 'JUNIO'},
      {id: 7, name: 'JULIO'},
      {id: 8, name: 'AGOSTO'},
      {id: 9, name: 'SEPTIEMBRE'},
      {id: 10, name: 'OCTUBRE'},
      {id: 11, name: 'NOVIEMBRE'},
      {id: 12, name: 'DICIEMBRE'}
    ],
    formOld:{
        code: '',
        name: '',
        cuota: '',
        especial: '',
        category_id: '',
        concept_id: 0,
        amount: 0,
        start_date: '',
        description: '',
        comision: false,
        cajaahorros: false,
        sostenimiento: false,
        inscripcion: false,
        delivery: false,
        parroquia: [],
        se: false,
        sales_limit: 1,
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
    this.getDataForm()
  },

  methods: {

    cambioSalesLimit(){
      if (this.form.sales_limit < 1) {
        this.form.sales_limit = 1
      }
    },

    incrementLimits(){
      this.form.sales_limit++
    },

    decrementLimits(){
      if (this.form.sales_limit > 1) {
        this.form.sales_limit--
      }
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('responseLoading', true)
        this.submitFormConceptos()
      }
    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },

    async getDataForm () {
        this.$emit('responseLoading', true)
        await axios.get('/api/administration/conceptos/categorias').then(resp => {
            let conceptF = resp.data.concepts_father
            conceptF.unshift({ id: 0, name: 'SIN CONCEPTO' })
            this.categorias = resp.data.categories
            this.concepts_father = conceptF
        })
        .catch(error => { console.log(error.response) })
        .finally(() => this.$emit('responseLoading', false));
    },

    async submitFormConceptos () {
      try {
        if (this.tipo == 'crear' || this.tipo == '') {
          const { data } = await axios.post('/api/administration/conceptos/create-concept', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch(`/api/administration/conceptos/update-concept/${this.datos.concept_id}`, this.form)
          this.cerrarDialog(data)
        }
        console.log(data)
        this.form = {
          code: '',
          name: '',
          cuota: '',
          especial: '',
          category_id: '',
          concept_id: 0,
          amount: 0,
          start_date: '',
          description: '',
          comision: false,
          cajaahorros: false,
          sostenimiento: false,
          inscripcion: false,
          delivery: false,
          parroquia: [],
          se: false,
          sales_limit: 1,
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.$emit('responseLoading', false)
        if (e.response.data.errors) {
          // this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.code) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.code[0]
            })
          }else if (e.response.data.errors.name) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.name[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }
    },

    cerrarDialog (data) {
      this.$emit('closeDialogConcepto', data)
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.$emit('responseLoading', false)
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/FormConceptos.vue